import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Webform } from '@uncinc/react-drupal-core';
import type { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import { WEBFORM_ID_SUPPORT } from '../../config/constants';
import useClasses from '../../hooks/useClasses';
import usePopup from '../../hooks/usePopup';
import useTypedDispatch from '../../hooks/useTypedDispatch';
import { toggleSupportTool } from '../../store/actions/UI';
import Button from '../Button';
import Popup from '../Popup';

import './style.scss';

const Support: React.FC = () => {
  const dispatch = useTypedDispatch();
  const { t } = useTranslation();
  const { buildClass } = useClasses('Support');

  const isOpen = useSelector<ImmutableRootState<boolean>, boolean>((state) => state.getIn(['uiInternal', 'showSupportTool'], false));

  const [showCloseButton, setShowCloseButton] = useState(false);

  const popup = usePopup('support-popup', {
    closeOnOutsideClick: true,
    closeOnRouteChange: false,
    onClose: () => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      dispatch(toggleSupportTool(false));
      setShowCloseButton(false);
    },
  });

  useEffect(() => {
    if (isOpen) {
      popup.open();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <>
      <Button
        iconOnly
        icon="support"
        className={buildClass('button')}
        aria-label={t('aria_labels.support')}
        onClick={() => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          dispatch(toggleSupportTool(true));
        }}
      />

      {popup.isOpen && (
        <Popup
          {...popup.popupProps}
          showCloseButton={showCloseButton}
        >
          <div className={buildClass('form')}>
            <Webform
              id={WEBFORM_ID_SUPPORT}
              onSuccessfullSubmit={() => {
                setShowCloseButton(true);
              }}
              overriddenComponents={{
                // eslint-disable-next-line react/no-unstable-nested-components
                webform_actions: ({ handleSubmit }: { handleSubmit: () => void }) => (
                  <div className={buildClass('actions')}>
                    <Button onClick={() => handleSubmit()}>
                      {t('buttons.send')}
                    </Button>

                    <button
                      type="button"
                      className="Popup__close"
                      onClick={() => popup.close()}
                    >
                      {t('buttons.cancel')}
                    </button>
                  </div>
                ),
              }}
            />
          </div>
        </Popup>
      )}
    </>
  );
};

export default Support;
